import MouseTrap from "mousetrap";
import { Constants } from "../../model/Constants";
import ModalMgr from "../../util/ModalMgr";
import {infomodalRender} from "../templates/renders/infomodal";

/**
 * Custom element for display disclaimers info confirmation dialog
 * @type {{template, created(), tagName: string, onOkClick(): void}}
 */
const InfoModalView: any = {
    tagName: "info-modal-view",
    renderer : infomodalRender,
    initialize(options) {
        const appInstance = options.$app;
        const viewConstants = options.constants;
        const config = appInstance.getUIConfig();
        viewConstants.closeButtonText = config.appStringProps.infoModalOkButtonText
                 || Constants.OK;
        viewConstants.btnStyles = config.modalButtonStyles;
    },
    created() {
        this.mouseTrap = new MouseTrap(this.el);
        this.bindKeyboardShortcuts();
        this.focusOkButton();
    },

    /**
     * Bind keyboard shortcuts
     */
    bindKeyboardShortcuts() {
        this.mouseTrap.bind("escape", () => this.onOkClick());
        this.mouseTrap.bind("tab", (e) => ModalMgr.onTab(e, this.el));
        this.mouseTrap.bind("shift+tab", (e) => ModalMgr.onShiftTab(e, this.el));
    },

    /**
     * Focuses the OK button when the modal pop-ups, for accessibility
     * @throws {Error} if it can't find the button
     */
    focusOkButton() {
        const infoModalOkButtonCSSSelector = '.modal-button[ld-on-click="onOkClick"]';
        const infoModalOkButton = this.el.querySelector(infoModalOkButtonCSSSelector);
        infoModalOkButton.focus();
    },

    /**
     *  click ok modal button, removes the modal from the window
     */
    onOkClick() {
        this.el.parentElement.removeChild(this.el);
        ModalMgr.removeNegativeTabIndexOnClosingModal();
    },
    removed() {
        this.mouseTrap.unbind("escape");
        this.mouseTrap.unbind("tab");
        this.mouseTrap.unbind("shift+tab");
        this.$app.getStateMgr().setState({ isModalVisible: false });
    },
};

/**
 * @export
 * @param   {CIApp} appInstance App instance
 * @return  {InfoModalView}    View instance
 */
export default appInstance => {
    InfoModalView.$app = appInstance;

    /**
     * @type {Object}
     */
    const constObj: any = {};

    InfoModalView.constants = constObj;

    return InfoModalView;
};
